// Module
var code = "<div layout=\"row\" layout-align=\"space-around center\">\n    <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular>\n</div>\n";
// Exports
module.exports = code;